"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationReferral',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        contact: '已接触',
        register: '已注册',
        qualify: '合格',
        convert: '转化',
        pay: '发红包',
        invalid: '作废'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationReferralListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('被推荐人姓名', '去推荐').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationReferralSaveApi)({
          targetName: value || '同行张工',
          targetType: 'peer',
          targetMobile: '13800000000',
          rewardAmount: 50
        }).then(function () {
          _this2.$message.success('推荐已提交');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationReferralActionApi)(row.referral.id, {
          action: action,
          conversionType: 'lead'
        }).then(function () {
          _this3.$message.success('推荐已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};